module.exports = __webpack_public_path__ + "static/media/Social_Twitter_active.ccc4b82a.svg";